import React from 'react';
import { ALargeSmall } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export type TextSize = 'small' | 'medium' | 'large';

interface TextSizeSelectorProps {
  textSize: TextSize;
  onTextSizeChange: (size: TextSize) => void;
}

const TextSizeSelector: React.FC<TextSizeSelectorProps> = ({
  textSize,
  onTextSizeChange,
}) => {
  const { t } = useLanguage();

  const sizes: { key: TextSize; label: string; fontSize: string }[] = [
    { key: 'small', label: 'A', fontSize: '12px' },
    { key: 'medium', label: 'A', fontSize: '16px' },
    { key: 'large', label: 'A', fontSize: '20px' },
  ];

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-3">
            <ALargeSmall className="w-5 h-5 text-muted-foreground shrink-0" />
            <div className="flex rounded-lg border border-border overflow-hidden flex-1">
              {sizes.map((size) => (
                <button
                  key={size.key}
                  onClick={() => onTextSizeChange(size.key)}
                  className={`flex-1 py-2 font-medium transition-colors ${
                    textSize === size.key
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-background text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                  style={{ fontSize: size.fontSize }}
                >
                  {size.label}
                </button>
              ))}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t.textSize}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TextSizeSelector;
